function getFormattedLocale(locale: string) {
  const [, language, country] = locale.match(/^(\w{2})[-_](\w{2})$/);
  const separator = '-';

  return [language.toLowerCase(), country.toLowerCase()].join(separator);
}

function isLocaleLanguage(locale: string, language: string) {
  locale = locale.toLowerCase();
  language = language.toLowerCase();

  return locale.startsWith(language);
}

export { getFormattedLocale, isLocaleLanguage };
